import cn from 'classnames';
import React from 'react';

import type { ContentBlock as Props } from './content-block.types';

const ContentBlock: React.FC<React.PropsWithChildren<Props>> = ({
  center,
  children,
  id,
  onFixedAlternateBackground,
  type,
}) => (
  <div
    className={cn('content-blocks__block', {
      'content-blocks__block--center': center,
      'content-blocks__block--on-fixed-alternate-background':
        onFixedAlternateBackground,
    })}
    data-block-id={id}
    data-block-type={type}
  >
    {children}
  </div>
);

export default ContentBlock;
